import OverlayBase from 'stimulus/overlay_base';

export default class extends OverlayBase {
  static targets = ['modal'];

  static values = {
    dismissible: { type: Boolean, default: true },
    triggerId: String,
  };

  connect() {
    super.connect();
    if (!this.element.hidden) this.dispatch('open');
  }

  get panel() {
    return this.hasModalTarget ? this.modalTarget : null;
  }

  get triggerSelector() {
    return this.triggerIdValue ? `#${CSS.escape(this.triggerIdValue)}` : null;
  }

  // Dismissal requested by the user (backdrop click, Esc, a close action).
  // A non-dismissible modal ignores it.
  close() {
    this.dismiss();
  }

  dismiss() {
    if (this.dismissibleValue) this.forceClose();
  }

  // Programmatic close: it closes even a non-dismissible modal.
  forceClose() {
    if (this.element.hidden) return;

    this.finishClose();
  }
}
